import {apiCall} from '@/api-transport/client';

type LoginParams = {
  email_address: string;
  password: string;
};

export type SignInResult = {
  kind: 'passkey_setup_required' | 'passkey_required';
};

type SignInResponse = {status: 'passkey_setup_required' | 'passkey_required'};

export async function signIn({
  email_address,
  password,
}: LoginParams): Promise<SignInResult> {
  const response = await apiCall<SignInResponse>('/private/signIn', {
    email: email_address,
    password,
  });

  return {kind: response.status};
}

export async function signOut() {
  await apiCall<void>('/private/signOut', {});
}
